import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Sparkles } from "lucide-react";
import { api, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) { navigate("/"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        if (data.token) setToken(data.token);
        setUser(data.user);
        window.history.replaceState(null, "", "/app");
        navigate(data.user.onboarded ? "/app" : "/onboarding", { replace: true, state: { user: data.user } });
      } catch {
        setError(true);
        setTimeout(() => navigate("/"), 2500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen aurora bg-background grid place-items-center text-foreground">
      <div className="text-center">
        <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 grid place-items-center mx-auto mb-5 shadow-xl shadow-indigo-500/40">
          <Sparkles className="text-white" size={26} />
        </div>
        {error ? (
          <p className="text-rose-400 font-semibold">Sign-in failed. Redirecting…</p>
        ) : (
          <div className="flex items-center gap-2 text-muted-foreground"><Loader2 className="animate-spin" size={18} /> Signing you in…</div>
        )}
      </div>
    </div>
  );
}
